import { useTranslation } from 'react-i18next';
import { Button, Flex, Text } from '@chakra-ui/react';

import { useIsMobile } from '@izimi/hooks';

import { BjornIllustrationHor } from './images/BjornIllustrationHor';
import { BjornIllustrationVer } from './images/BjornIllustrationVer';
import { IzimiLogo } from './images/IzimiLogo';

type Props = {
  vertical?: boolean;
  onIzimiAdCtaButtonClick?: VoidFunction;
};

export const NabanIzimiAd = (
  { vertical = false, onIzimiAdCtaButtonClick }: Props = { vertical: false },
) => {
  const isMobile = useIsMobile();
  const {
    t,
    i18n: { language },
  } = useTranslation('naban');

  const onClick = () => {
    onIzimiAdCtaButtonClick?.();
    window.open(`https://app.izimi.be?lng=${language}`);
  };

  return (
    <Flex
      overflow='hidden'
      borderRadius='30px'
      flexDirection={vertical ? 'column' : 'row'}
      w='full'
      maxWidth='50rem'>
      <Flex flexGrow={1} flexShrink={0}>
        {isMobile ? (
          <BjornIllustrationVer height='auto' width='auto' />
        ) : (
          <BjornIllustrationHor height='auto' />
        )}
      </Flex>
      <Flex backgroundColor='neutral100' p={{ base: 6, md: 10 }} gap={8}>
        <Flex
          flex={1}
          justifyContent='center'
          alignItems='flex-start'
          flexDirection='column'
          gap={2}>
          <Text variant='heading2'>{t('izimiAd.title')}</Text>
          <Text>{t('izimiAd.description')}</Text>
          <Button variant='primary500' backgroundColor='secondary400' mt={2} onClick={onClick}>
            {t('izimiAd.cta.label')}
          </Button>
        </Flex>
        <Flex>
          <IzimiLogo />
        </Flex>
      </Flex>
    </Flex>
  );
};
